export default {
  mounted() {
    this.fields = Array.from(
      this.el.querySelectorAll('input[type="text"], select, input[type="date"]'),
    )
    this.initialize()
    this.autofocusField = this.fields.find(field => field.autofocus)
    this.fields.forEach(field => {
      field.addEventListener('blur', _e => {
        this.blur(field)
      })
    })
    this.fields.forEach(field => {
      field.addEventListener('focus', _e => {
        this.focus(field)
      })
    })
    if(typeof(this.autofocusField) !== 'undefined'){ this.autofocusField.focus() }
  },
  updated() {
    this.initialize()
  },
  blur(field) {
    field.classList.add('pl-0', 'border-0')
  },
  focus(field) {
    field.classList.remove('pl-0', 'border-0')
  },
  initialize() {
    this.fields.forEach(field => {
      if (document.activeElement.id !== field.id) {
        this.blur(field)
      }
    })
  },
}
